<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('stockIn.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('stockIn.pageTitle'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <div class="ts-flex ts-items-center ts-space-x-3">
            <ts-button outline color="info" @click.prevent="addNew">
              {{ $t('add_new') }}
            </ts-button>
            <a-range-picker
              v-model="dateRange"
              :allowClear="false"
              format="DD-MM-YYYY"
              valueFormat="DD-MM-YYYY"
              style="width: 200px"
              @change="fetchData()"
            />
          </div>
          <div class="d-flex ts-space-x-3 ts-items-center">
            <div
              class="
                ts-border-gray-200
                ts-border
                ts-rounded
                ts-p-2
                ts-flex
                ts-items-center
              "
            >
              <input
                v-model="inactive"
                @change="fetchData()"
                type="checkbox"
                id="inactive"
              />
              <label for="inactive" class="ts-mb-0 ts-ml-1">{{
                $t('stockIn.inactive')
              }}</label>
            </div>
            <ts-input
              v-model="search"
              v-tooltip="$t('stockIn.search')"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
            <ts-filter ref="filter">
              <div class="row">
                <div class="col-md-12">
                  <label class="">{{ $t('employeeProfile.branch') }}</label>
                  <ts-branch-filter
                    @filter="branchFilter"
                    class="ts-w-full"
                  ></ts-branch-filter>
                </div>
              </div>
              <div class="row ts-mt-4">
                <div class="col-md-12">
                  <label>{{ $t('purchaseOrder.vendor') }}</label>
                  <a-select
                    show-search
                    mode="multiple"
                    :placeholder="$t('all')"
                    v-model="vendor_id"
                    showSearch
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    :options="vendor"
                    class="ts-w-full"
                  ></a-select>
                </div>
              </div>
            </ts-filter>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'stock_in_date',
          }"
        >
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              {{ record.branch.branch_name_en }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.stock_in_number }}</td>
            <td class="ts-whitespace-no-wrap">
              {{
                record.purchase_order ? record.purchase_order.po_number : null
              }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.invoice_no }}</td>
            <td class="ts-whitespace-no-wrap ts-text-right">
              <p class="ts-mb-0 ts-font-extrabold ts-text-blue-700">
                {{ sumTotalAmount(record.stock_in_details) }}
              </p>
            </td>
            <td class="ts-text-right">
              <p class="ts-mb-0 ts-font-extrabold ts-text-blue-700">{{ sumTotalAmountToBath(record.stock_in_details, record.fx_bath) }}</p>
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.supplier ? record.supplier.vendor_name : null }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.location.location_name_en }}
            </td>
            <td class="ts-text-center">
              <span class="badge badge-success" v-if="record.is_confirm_stock"
                >Yes</span
              >
              <span class="badge badge-danger" v-else>No</span>
            </td>
            <td class="ts-text-center">
              {{ record.confirmed_date }}
            </td>
            <td class="ts-text-center">
              {{ record.comfirmed_by ? record.comfirmed_by.name : '' }}
            </td>
            <td class="text-center ts-space-x-3">
              <a
                href="#"
                v-tooltip="$t('deliveryOrder.reprint')"
                class="text-primary text-red"
                @click.prevent="previewPdf(record)"
              >
                <i class="fas fa-file-pdf"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a-popconfirm
                placement="leftTop"
                :title="$t('are_you_sure_to_delete')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="deleteRecord(record)"
              >
                <a href="#" :disabled="record._deleting">
                  <i
                    class="fas fa-circle-notch spin"
                    v-if="record._deleting"
                  ></i>
                  <i class="fa fa-trash text-red" v-else></i>
                </a>
              </a-popconfirm>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
    <a-modal :title="$t('pdf')" width="50%" v-model="show_pdf" :footer="null">
      <ts-preview-pdf v-model="waiting" :src="src" />
    </a-modal>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import moment from 'moment'
export default {
  name: 'stockIn',
  data() {
    return {
      loading: false,
      waiting: false,
      src: null,
      show_pdf: false,
      vendor_id: [],
      vendor: [],
    }
  },
  created(){
    // this.$store.state.stock.stockIn.dateRange = [moment().add(-7, 'days').format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')]
    this.fetchData()
    this.getVendor()
  },
  computed: {
    ...mapState('stock/stockIn', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.stock.stockIn.search
      },
      set(newValue) {
        this.$store.commit('stock/stockIn/SET_SEARCH', newValue)
        this.$store.commit('stock/stockIn/RESET_CURRENT_PAGE')
      },
    },
    inactive: {
      get() {
        return this.$store.state.stock.stockIn.isInActive
      },
      set(newValue) {
        this.$store.commit('stock/stockIn/SET_IS_INACTIVE', newValue)
      },
    },
    dateRange: {
      get() {
        return this.$store.state.stock.stockIn.dateRange
      },
      set(newValue) {
        this.$store.commit('stock/stockIn/SET_DATE_RANGE', newValue)
      },
    },
    columns() {
      return [
        { name: this.$t('stockIn.branch') },
        { name: this.$t('stockIn.stockInNumber') },
        { name: this.$t('stockIn.poNumber') },
        { name: this.$t('stockIn.invoiceNumber') },
        { name: this.$t('stockIn.amount'), style: 'text-align:right' },
        { name: this.$t('stockIn.amountInBath'), style: 'text-align:right' },
        { name: this.$t('stockIn.supplier/vendor') },
        { name: this.$t('stockIn.warehouse') },
        {
          name: this.$t('stockIn.confirmStock'),
          style: 'text-align:center; width:7%',
        },
        {
          name: this.$t('stockIn.confirmDate'),
          style: 'text-align:center; width:7%',
        },
        {
          name: this.$t('stockIn.confirmBy'),
          style: 'text-align:center; width:7%',
        },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width:7%',
        },
      ]
    },
  },
  methods: {
    addNew() {
      this.$router.push({ name: 'stock-in-create' })
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('stock/stockIn/fetch', { ...attributes })
        .then((response) => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('stock/stockIn/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'stock-in-edit',
        params: { id: record.stock_in_id },
      })
    },
    deleteRecord(record) {
      record._deleting = true
      this.$store
        .dispatch('stock/stockIn/destroy', record.stock_in_id)
        .then((response) => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
    branchFilter(value) {
      this.$store.commit('stock/stockIn/SET_BRANCH_ID', value)
      this.fetchData()
    },
    previewPdf(record) {
      this.show_pdf = true
      this.waiting = true
      this.src = ''
      this.$store
        .dispatch('stock/stockIn/toPdf', record.stock_in_id)
        .then((response) => {
          this.src = response.url
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    getVendor() {
      this.vendor = []
      this.$store.dispatch('stock/stockIn/getVendor').then((response) => {
        this.vendor = response.data.map((el) => ({
          value: el.vendor_id,
          label: el.vendor_name,
        }))
      })
    },
    vendorFilter(value) {
      this.$store.commit('stock/stockIn/SET_VENDOR', value)
      this.fetchData()
    },
    sumTotalAmount(details = []) {
      return this.$currencyFormat(
        _.round(_.sumBy(details, 'total_after_discount'), 2)
      )
    },
    sumTotalAmountToBath(details = [], fx = 32){
      let sum = _.sumBy(details, 'total_after_discount')
      fx = fx ? fx : 32
      return this.$currencyFormat(_.round( sum * fx, 2), 'THB', '', 2)
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500),
    vendor_id: debounce(function (value) {
      this.vendorFilter(value)
    }, 500),
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('stock/stockIn/RESET_STATE')
    next()
  },
}
</script>